// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607280403/js/" + chunkId + "." + {"44":"1687b938","225":"a9d56ceb","481":"94479d99","486":"ffd10cb8","770":"83471278"}[chunkId] + ".0.5687094502289719.chunk.js";
};